import type { ActiveIntegrationResponse } from '../types';

export const isIntegrationMelhorEnvio = (integration: ActiveIntegrationResponse) => {
  return integration.logisticType === 'MELHORENVIO';
};

export const isIntegrationActive = (integration: ActiveIntegrationResponse) => {
  return integration.status === 'ACTIVE';
};
